import React from "react";
//#region types
import { NestedTableHandles } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { usePrevious } from "components/common";
//#endregion

// Keeps the table in step with the persisted expandAllRows flag. Rows re-expand whenever new data loads, and collapse
// only when the flag is turned off (e.g. "Återställ" in the filter drawer), so rows a user opened by hand survive a refetch.
function useApplyExpandAllRows(
  tableRef: React.RefObject<NestedTableHandles>,
  result: unknown,
  expandAllRows?: boolean
) {
  const wasExpanded = usePrevious(expandAllRows);

  React.useEffect(() => {
    if (expandAllRows) {
      tableRef.current?.expandAll();
    } else if (wasExpanded) {
      tableRef.current?.collapseAll();
    }
  }, [result, expandAllRows]);
}

export default useApplyExpandAllRows;
